import { useQuery } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { userQuery, UserQuery } from "generated/graphql";
import React, { createContext } from "react";
import { getFullName, hasValue } from "Tools";

export const UserContext = createContext<{ user: UserQuery["user"] | null }>({
  user: null,
});

export function UserProvider(props: {
  children: (renderProps: {
    user: UserQuery["user"] | null;
  }) => React.ReactNode;
}) {
  const { data, error, loading } = useQuery(userQuery);
  if (loading || hasValue(error)) {
    return <>Loading user data...</>;
  }
  const user = data?.user ?? null;
  if (hasValue(user)) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: getFullName(user),
    });
  }
  return (
    <UserContext.Provider value={{ user }}>
      {props.children({ user })}
    </UserContext.Provider>
  );
}
